import { createFileRoute } from "@tanstack/react-router";
import { OrganizationDetailPage } from "../../../components/organizations/OrganizationDetailPage";

export const Route = createFileRoute("/workspace/organizations/$orgId/")({
  component: OrganizationDetailRoute,
});

function OrganizationDetailRoute() {
  const { orgId } = Route.useParams();
  return <OrganizationDetailPage orgId={orgId} />;
}
